import { useSearchParams } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/input/Select";
import { MONTHS } from "./months";

interface MonthYearFilterProps {
  month: string;
  year: string;
  onChange: (value: { month: string; year: string }) => void;
}

export default function MonthYearFilter({
  month,
  year,
  onChange,
}: MonthYearFilterProps) {
  const thisYear = new Date().getFullYear();
  const years = Array.from({ length: 12 }, (_, i) => String(thisYear - 3 + i));

  const [searchParams, setSearchParams] = useSearchParams();

  const handleMonthChange = (newMonth: string) => {
    onChange({ month: newMonth, year });

    const params = new URLSearchParams(searchParams);
    if (newMonth) {
      params.set("month", newMonth);
    } else {
      params.delete("month");
    }
    setSearchParams(params);
  };

  const handleYearChange = (newYear: string) => {
    onChange({ month, year: newYear });

    const params = new URLSearchParams(searchParams);
    if (newYear) {
      params.set("year", newYear);
    } else {
      params.delete("year");
    }
    setSearchParams(params);
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 items-center w-full max-w-md">
      {/* Month Picker */}
      <div className="w-full">
        <Select
          value={month ?? ""}
          onValueChange={(value) => handleMonthChange(value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select month" />
          </SelectTrigger>
          <SelectContent>
            {MONTHS.map((m) => (
              <SelectItem key={m.value} value={m.value}>
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Year Picker */}
      <div className="w-full">
        <Select
          value={year ?? ""}
          onValueChange={(value) => handleYearChange(value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select year" />
          </SelectTrigger>
          <SelectContent>
            {years.map((y) => (
              <SelectItem key={y} value={y}>
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
